<template>
    <div class="page-menu-float">
        <div class="menu-inner">
            <ul v-for="(item, index) in menu" :class="setUlClass(index)">
                <li class="head" v-on:click="openMenu(index)"><span>{{ index+1 }}</span> {{ item.name }}</li>
				<li class="menu-content">
					<ol>
						<li v-for="(sub, subIndex) in item.sub">
                            <div :class="{ 'selected':  routeSection==index && routeLevel==subIndex}">
                               <span>{{ index+1 }}.{{ subIndex+1 }}</span> <a :href="createLink(index, subIndex)" @click.prevent="onMenuLinkClick(index, subIndex)">{{ sub }}</a>
                            </div>
						</li>
					</ol>
				</li>
            </ul>
        </div>

        <div class="buttons" v-if="$store.state.editor.version">
            <div v-if="isSuperAdmin()" style="margin-bottom:40px;font-size:8px;">
                <div v-if="!isAggregation()">
                  <a v-bind:href="'/api/download/viewinputjson?id=' + $store.state.editor.version.forecastVersionId" target="_blank" style="color:white;">Download input json</a>
                </div>
            </div>
            <template v-if="$store.state.editor.version.processStatus == 1 || $store.state.editor.version.processStatus == 4">
                <p v-if="$store.state.editor.validator.hasWarning" class="warning">
                    <span v-on:click="onModalValidatorClick">Click for warnings</span>
                </p>
                <p v-if="$store.state.editor.validator.hasError" class="valid">
                    <span v-on:click="onModalValidatorClick">Click for required data</span>
                </p>
                <p>
                    Last saved: {{ this.$moment.utc($store.state.editor.version.updateDate).local().format("DD MMM YYYY HH:mm:ss") }}
                </p>
                
                 <input type="button" class="left" v-on:click="onRunClick($event)" :disabled="$store.state.editor.validator.hasError" value="Run" />
                
                    
                 <button class="right" :class="{'loading': this.$store.state.isSavingStudy}" v-on:click="onSaveClick($event)">Save</button>
            </template>                                    
            <template v-if="$store.state.editor.version.processStatus == 2">
                <button class="left" v-on:click="onViewClick($event)">View</button>
                <button class="right" v-on:click="onCopyClick($event)" v-if="!$parent.showAnonymousMenu">Copy</button>
            </template>
            <template v-if="$store.state.editor.version.processStatus == 3">
                <button class="left loading">Running...</button>
                <button class="right" v-on:click="onCopyClick($event)">Copy</button>
            </template>
        </div>
    </div>
</template>

<script>
    
    export default {
        props: {
            menu: {
                type: Array,
                required: true
            }
        },
        mounted (){
            // Subscribe to save study event, and validate study when auto saving
            this.$store.state.editor.validator.event = this.$store.subscribeAction((action, state) => {
                if(action.type === "saveForecastVersion"){
                    this.validateVersion(action.payload)
                }
            })

            this.routeSection = parseInt(this.$route.params.section);
            this.routeLevel = parseInt(this.$route.params.level);
        },
        data: () => (
                {
                    routeSection: 0,
                    routeLevel: 0
                }
            )
        ,
        beforeDestroy() {
            this.$store.state.editor.validator.event(); // Unsubscribe
        },
        methods: {
                      
            isSuperAdmin() {
                return this.$store.state.member.isSuperAdmin;
            },
            isAggregation() {
                return this.$router.currentRoute.name.indexOf("Aggregator") > -1
            },
            onMenuLinkClick (index, subIndex){                
                this.routeSection = index;
                this.routeLevel = subIndex;
                this.$parent.goToPage(index, subIndex)
            },
            createLink(section, level){
                return this.createEditorMenuUrl(this.$parent.editorType, section, level);
            },           
            openMenu(index) {
                document.querySelectorAll(".page-menu ul").forEach((elm) =>{
                    elm.classList.remove("opened");
                    elm.classList.add("closed");
                });

                let ul = document.querySelectorAll(".page-menu ul")[index];
                ul.classList.remove("closed");
                ul.classList.add("opened");
            },
            setUlClass(index) {
                return this.$route.params.section == index ? "opened" : "closed";
            },
            createProjectPayload(currentVersion){
                // Create a "new" Project and post to server
                // todo: move this to new forecast service
              //debugger;
                let data = {
                    project: {...this.$parent.project},
                    type: this.$parent.editorType,
                    title: currentVersion.title,
                    forecastVersionId: currentVersion.forecastVersionId
                };

                data.project.programs = [];
                data.project.programs.push({...this.$parent.program});

                if(this.$parent.editorType === "study"){
                    data.project.programs[0].studies = [];
                    data.project.programs[0].studies.push({...this.$parent.forecast});

                    data.project.programs[0].studies[0].forecastVersions = [];
                    data.project.programs[0].studies[0].forecastVersions.push({...currentVersion});
                }
                else {
                    data.project.programs[0].studies = [];
                    data.project.programs[0].forecastVersions = [];
                    data.project.programs[0].forecastVersions.push({...currentVersion});
                    //debugger;
                    // Find studies (Used in final Study.json file)
                    let studies = [];
                    if (!this.NullOrUndefined(currentVersion.data.ancillary))
                    {
                      for(let data of currentVersion.data.ancillary.mappings)
                          studies.push(...data.studies);
                    }
                    
                    if (!this.NullOrUndefined(currentVersion.data.dispensingUnit)) {
                      for (let data of currentVersion.data.dispensingUnit.mappings)
                        studies.push(...data.studies);
                    }

                    if (!this.NullOrUndefined(currentVersion.data.packingCampaign)) {
                      for (let data of currentVersion.data.packingCampaign.mappings)
                        studies.push(...data.studies);
                    }

                    
                   if (!this.NullOrUndefined(currentVersion.data.depotMappings)) {
                     for (let data of currentVersion.data.depotMappings)
                       for (let depot of data.sites)
                         for (let s of depot.selectedRows)
                           studies.push(s.split("_")[0]);

                   }

                    // todo: fix this ugly loop
                  if (!this.NullOrUndefined(currentVersion.data.siteMappings)) {
                    for (let data of currentVersion.data.siteMappings)
                      for (let depot of data.sites)
                        for (let s of depot.selectedRows)
                          studies.push(s.split("_")[0]);

                  }
                    let count = 0;
                    for(let id of [...new Set(studies)]){
                        let study = this.$store.getters.study(id);
                        if(!study)
                            console.log(id + " failed")

                        data.project.programs[0].studies.push({...study});

                        data.project.programs[0].studies[count].forecastVersions = [];
                        data.project.programs[0].studies[count].forecastVersions.push({...study.forecastVersions.find(x => !this.isEmptyObject(x.data))});
                        count++;
                    }
                }

                return data;
            },
            onRunClick(e){
                e.preventDefault();
                //debugger;
                e.target.classList.add("loading");
                
                let version = this.$store.state.editor.version;
                
                //review table only exists under a study
                if (!this.NullOrUndefined(version.data) && this.NullOrUndefined(version.data.studies))
                    this.updateShipperReviews(version.data);

                version.processStatus = 3;
                version.processStatusName = "Running";
                
                this.$store.dispatch("runAggregator", this.createProjectPayload(version)).then((res) => {
                    
                   
                  
                }).catch((res) => {
                    e.target.classList.remove("loading");
                    this.$store.state.editor.version.processStatus = 4;
                    this.$store.state.editor.version.processStatusName = "Failed";
                })
            },
            onSaveClick(e){
                this.$store.dispatch("saveCurrentForecastVersion");
            },
            onViewClick(e) {
                this.$router.push("/view/" +  this.$store.state.editor.version.forecastId + "/demand");
            },          
            onCopyClick(e) {
                this.$store.dispatch("copyCurrentForecastVersion").then(res =>{
                    this.$router.push("/" + this.$parent.editorType + "/" + res.parentId + "/0/0/" + res.forecastVersionId);
                });
            },
            validateVersion(data){
                this.$store.dispatch("validateAggregator", this.createProjectPayload(data)).then((res) => {

                    this.$store.state.editor.validator.hasError = res.hasError;
                    this.$store.state.editor.validator.hasWarning = res.hasWarning;
                    this.$store.state.editor.validator.errors = res.errors;
                    this.$store.state.editor.validator.warnings = res.warnings;

                }).catch((res) => {
                    this.$store.state.editor.validator.hasError = false;
                    this.$store.state.editor.validator.errors = [];
                    this.$store.state.editor.validator.hasWarning = false;
                    this.$store.state.editor.validator.warnings = [];
                })
            },
            onModalValidatorClick(){
                this.$parent.$refs.modalValidator.show();
            }
        }
    }
</script>